/* eslint-disable @typescript-eslint/naming-convention */
import {FormElementTextTypes, FormElementType} from '../enums';
import 'reflect-metadata';
import {FormElement, FormElementConfiguration} from 'app/entities/form/formElement.entity';
import {Type} from 'class-transformer';

export class FormElementText extends FormElement {
  type: FormElementType = 'text';

  @Type(() => FormElementTextConfiguration)
  configuration?: FormElementTextConfiguration = new FormElementTextConfiguration();
}

export class FormElementTextConfiguration extends FormElementConfiguration {
  type?: FormElementTextTypes = 'text';
  mask?: string = null;
  minLength?: number = null;
  maxLength?: number = null;
  clearable = true;
}
